import DeviceRCStatus from './DeviceRCStatus';

export default DeviceRCStatus;
